var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoInner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3VO Logos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3VO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.17871 0C9.23042 5.86632 19.0305 9.38298 29.5658 9.58089C23.8553 12.5717 17.5302 14.4814 10.8399 15.0514L1.17871 0Z",
    fill: "#0CDBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5206 16.112L15.3 22L21.0172 14.2347C17.9195 15.1473 14.7411 15.7671 11.5206 16.112Z",
    fill: "#0CDBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4637 8.19556L29.4211 2.82053L29.4168 2.8201C26.335 4.61928 23.0551 6.09583 19.6197 7.20566C21.5428 7.65486 23.494 7.98635 25.4637 8.19556Z",
    fill: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInner);
export default __webpack_public_path__ + "static/media/logo-inner.78f672109956bf1de9010adbe5cd83a0.svg";
export { ForwardRef as ReactComponent };